import React from 'react'
import Hero from '../components/Hero/Hero'
import Demo from '../components/Demo/Demo'
import Hero1 from '../components/Hero1/Hero1'
import Hero3 from '../components/Hero3/Hero3'

const Home = () => {
  return (
    <div>
      <Hero/>
      <Hero1/>
      <Hero3/>
      <Demo/>
    </div>
  )
}

export default Home